/* eslint-disable max-len */

export default {
  blocks: [
    {
      key: 'foo',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {
        dynamicStyles: {
          'padding-top': '0px',
          'padding-bottom': '0px',
        },
        textAlignment: 'justify',
      },
    },
    {
      key: 's53',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 0,
        },
      ],
      data: {},
    },
    {
      key: 'e3sob',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2ui77',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 1,
        },
      ],
      data: {},
    },
    {
      key: 'ev5ni',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dm5qe',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 2,
        },
      ],
      data: {},
    },
    {
      key: 'akn59',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9qfd3',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 3,
        },
      ],
      data: {},
    },
    {
      key: 'f5rqu',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': {
      type: 'wix-draft-plugin-divider',
      mutability: 'IMMUTABLE',
      data: {
        type: 'double',
        config: {
          size: 'medium',
          alignment: 'center',
          textWrap: 'nowrap',
        },
      },
    },
    '1': {
      type: 'wix-draft-plugin-image',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          alignment: 'center',
          size: 'small',
          showTitle: true,
          showDescription: true,
          textWrap: 'wrap',
        },
        src: {
          id: 'bbafa01c54087e7003f10c2c2a06a524',
          original_file_name: '8bb438_8d139a5df3aa4f709c66b8cdd28ac307.jpg',
          file_name: '8bb438_8d139a5df3aa4f709c66b8cdd28ac307.jpg',
          width: 5120,
          height: 3413,
        },
      },
    },
    '2': {
      type: 'wix-draft-plugin-vertical-embed',
      mutability: 'IMMUTABLE',
      data: {
        type: 'product',
        selectedProduct: {
          id: '265beaf5-3008-c5c2-fa5e-1447e0bebf71',
          name: 'flowers',
          pageUrl:
            'https://www.wix.app/stores/54e7b326-49ec-434f-a7cc-c2ad1eaec049/catalog/265beaf5-3008-c5c2-fa5e-1447e0bebf71?d=https://sapirs0.wixsite.com/mysite/product-page/flowers',
          imageSrc:
            'https://static.wixstatic.com/media/11062b_3a93dbce5ab64e7c90d9b2a83a598893~mv2.jpg/v1/fit/w_6720,h_4480,q_90/file.jpg',
        },
      },
    },
    '3': {
      type: 'wix-draft-plugin-poll',
      mutability: 'IMMUTABLE',
      data: {
        poll: {
          id: 'f3fa62b4-6d75-4016-a895-acb793ca6f5c',
          title: 'Where do you want to have breakfast tomorrow to use the monthly budget?',
          mediaId: 'https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg',
          createdBy: '3efa7e86-fc25-4ef1-a002-19769b84202f',
          settings: {
            multipleVotes: true,
            voteRole: 'SITE_MEMBERS',
            resultsVisibility: 'VOTERS_ONLY',
            votersDisplay: true,
            votesDisplay: true,
          },
          options: [
            {
              id: '067ed3b5-f19d-4886-8f23-acd84a586522',
              title: 'Cafe Nordoy',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_f12aec64c02f464c9d3f0f6d62ec7384~mv2.png',
            },
            {
              id: 'ee32a57f-bf6c-425a-a20c-e678bcf4a73b',
              title: 'קפה רוטשילד 65',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_c6ebbeecf9b4494f91244656beee6e78~mv2.jpg',
            },
            {
              id: '41679bf9-89ba-41f2-81d3-832d567531da',
              title: 'האחים',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_26d7f9c215944dbcb783c6b16f536c33~mv2.jpg',
            },
            {
              id: '378c6042-55cc-4e4a-9f0c-77824bee4964',
              title: 'הוטל מונטיפיורי',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_d9b16be508ce41aa8e635d0e9e97b923~mv2.jpeg',
            },
          ],
        },
        layout: {
          poll: {
            type: 'grid',
            direction: 'ltr',
            enableImage: false,
          },
          option: {
            enableImage: true,
          },
        },
        design: {
          poll: {
            backgroundType: 'image',
            background:
              'https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg',
            borderRadius: 0,
          },
          option: {
            borderRadius: 0,
          },
        },
        config: {
          alignment: 'center',
          size: 'large',
          width: 'full-width',
          textWrap: 'wrap',
        },
      },
    },
  },
  VERSION: '8.49.7',
};
